<script>
  // @ts-ignore
  import microphoneImage from '../assets/microphone.svg?inline'

  let { 
    list = {},
    choice = $bindable(null),
    primary = null,
    secondary = null,
    description = null,
    categories = {},
    suggest = {},
    textPlaceholder = 'Search...',
    textTitle = 'Choose',
    textSubtitle = null,
    textContinue = null, // 'Continue',
    textButtonBack = null,
    textButtonAction = null,
    buttonBack = null, // event
    buttonAction = null, // event
    buttonSelected = null, // event
    buttonPasskeyClick = null, // event
    noItemsHint = '',
    noMatchHint = '',
    doubleClick = null,
  } = $props();
  let filter = $state('');
  let filteredList = $state({});

  let selectedId = $state(null);
  let isValidSelection = $derived(!!selectedId && buttonSelected);

  function handleDoubleClick() {
    if (doubleClick) {
      doubleClick();
    }
  }

  function handleSelect(id) {
    selectedId = id;
    if (!textContinue && buttonSelected) {
      buttonSelected(id);
    }
  }

  function handleButtonBack() {
    if (buttonBack) {
      buttonBack();
    }
  }

  function handleButtonAction() {
    if (buttonAction) {
      buttonAction();
    }
  }

  function handleButtonSelected() {
    if (selectedId && buttonSelected) {
      buttonSelected(selectedId);
    }
  }

  // When filter changes, update the list
  $effect(() => {

    const queryParts = filter.trim().toLowerCase().replaceAll(/[^a-z0-9]/g, ' ').replaceAll('  ', '').split(' ').filter(x => x.length > 0).map(x => ({ 
      query: x,
      regExFull: RegExp('\\b' + x + '\\b', 'gmi'),
      regExStart: RegExp('\\b' + x, 'gmi'),
      regExMid: RegExp(x, 'gmi'),
    }));
    const resultsLimit = 20;

    const results = {};
    for (const category of Object.keys(categories)) {
        let categoryResults = [];
        for (const [id, content] of Object.entries(list)) {
            // Calculate category score
            let score = {
                full: 0,
                start: 0,
                mid: 0,
                none: 0,
            }
            const searchList = Array.isArray(content[category]) ? content[category] : [content[category]];
            for (const part of queryParts) {
                let hits = 0;
                for (const search of searchList) {
                    if (part.regExFull.test(search)) {
                        score.full++;
                        hits++;
                    } else if (part.regExStart.test(search)) {
                        score.start++;
                        hits++;
                    } else if (part.regExMid.test(search)) {
                        score.mid++;
                        hits++;
                    }
                }
                if (hits == 0) {
                    score.none++;
                }
            }

            // Calculate total
            let total = 0;
            total += 1000 * score.full;
            total += 100 * score.start;
            total += 1 * score.mid;
            total += -100 * score.none;

            // Add to results
            if (total > 0) {
                const entry = {
                    id,
                    score: total,
                };
                categoryResults.push(entry);
            }
        }

        // Sort categoryResults
        categoryResults.sort((a, b) => b.score - a.score);
        // Limit results
        categoryResults = categoryResults.splice(0, resultsLimit);

        if (categoryResults.length > 0) {
            // Add to results
            results[categories[category]] = categoryResults;
        }
    }

    // Sort keys by highest score
    const sortedKeys = Object.keys(results).sort((a, b) => (results[b].length > 0 ? results[b][0].score : 0) - (results[a].length > 0 ? results[a][0].score : 0));
    let sortedResults = {};
    for (const key of sortedKeys) {
        sortedResults[key] = results[key];
    }


    if (filter.trim() == '' && Object.keys(sortedResults).length == 0) {

      if (suggest.value == '*') {
        // Return all
        sortedResults = {
          // @ts-ignore
          [suggest.label]: Object.entries(list).map(([id, content]) => ({
            id,
            score: null,
          })),
        }
        if (sortedResults[suggest.label].length == 0) {
          sortedResults = {};
        }
      } else if (suggest) {
        // Return entries with non-falsy attribute specified
        sortedResults = {
          // @ts-ignore
          [suggest.label]: Object.entries(list).filter(([id, content]) => content[suggest.tag] == suggest.value).map(([id, content]) => ({
            id,
            score: null,
          })),
        }
        if (sortedResults[suggest.label].length == 0) {
          sortedResults = {};
        }
      }

      if (suggest.limit) {
        // Limit results
        for (const key of Object.keys(sortedResults)) {
          sortedResults[key] = sortedResults[key].splice(0, suggest.limit);
        }
      }
    }

    filteredList = sortedResults;

  });
</script>


<div class="container">

  <div class="button-container back">
    {#if textButtonBack}
      <button class="button back" onclick={() => { handleButtonBack(); }}>
        {textButtonBack}
      </button>
    {:else}
      <!-- Placeholder -->
      <!-- svelte-ignore a11y_consider_explicit_label -->
      <button class="button back" disabled style="visibility: hidden;">&nbsp;</button>
    {/if}
  </div>

  <div class="header">
    <div class="title">
      <!-- svelte-ignore a11y_click_events_have_key_events -->
      <!-- svelte-ignore a11y_no_static_element_interactions -->
      <svg class="logo" version="1.1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" onclick={() => { if (buttonPasskeyClick) buttonPasskeyClick() }}>
        <path fill="currentColor" d="m256 320a78.83 78.83 0 0 1-56.55-24.1 80.89 80.89 0 0 1-23.45-56.9v-111a79.69 79.69 0 0 1 80-80c44.86 0 80 35.14 80 80v111c0 44.66-35.89 81-80 81zm-128-128a16 16 0 0 0-16 16v32c0 73.715 56.322 135 128 143.04v48.955h-48a16 16 0 0 0-16 16 16 16 0 0 0 16 16h128a16 16 0 0 0 16-16 16 16 0 0 0-16-16h-48v-48.955c71.678-8.0463 128-69.33 128-143.04v-32a16 16 0 0 0-16-16 16 16 0 0 0-16 16v32c0 61.673-50.327 112-112 112s-112-50.327-112-112v-32a16 16 0 0 0-16-16z"/>
      </svg>
      <span ondblclick={handleDoubleClick}>{textTitle}</span>
    </div>
    {#if textSubtitle}
      <div class="subtitle">{textSubtitle}</div>
    {/if}
  </div>

  <div class="button-container major">
    {#if textButtonAction}
      <button class="button" onclick={() => { handleButtonAction(); }}>
        {textButtonAction}
      </button>
    {/if}
  </div>

  {#if textPlaceholder}
    <div class="search-container">
      <svg
        class="search-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input
        type="search"
        class="search-input"
        placeholder={textPlaceholder}
        bind:value={filter}
      />
    </div>
  {/if}

  <div class="paper-wrapper">

    {#if Object.keys(filteredList).length == 0}
      {#if filter.trim().length == 0}
        {#if textPlaceholder}
          {#if Object.entries(list).length == 0}
            <div class="divider">No items. {noItemsHint}</div>
          {:else}
            <div class="divider">Search to find items.</div>
          {/if}
        {:else}
          <!-- ... -->
        {/if}
      {:else}
        {#if Object.entries(list).length == 0}
          <div class="divider">No items. {noMatchHint}</div>
        {:else}
          <div class="divider">No matching results. {noMatchHint}</div>
        {/if}
      {/if}
    {:else}
      {#each Object.entries(filteredList) as [category, categoryList] (category)}
        <div class="divider">{category} ({categoryList ? categoryList.length : '-'})</div>

        <div class="papers-grid">
          {#each Object.values(categoryList) as entry (entry.id)}
            <!-- TODO: Fix these a11y issues ASAP -->
            <!-- svelte-ignore a11y_click_events_have_key_events -->
            <!-- svelte-ignore a11y_no_static_element_interactions -->
            <div
              class="paper-card"
              class:selected={selectedId === entry.id}
              onclick={() => handleSelect(entry.id)}
            >
              <div class="paper-title">{list[entry.id][primary]}</div>
              {#if secondary}
                <div class="paper-author">{list[entry.id][secondary]}</div>
              {/if}
              {#if description}
                <div class="paper-description">{list[entry.id][description]}</div>
              {/if}
            </div>
          {/each}
        </div>
    
        <ul>
        </ul>
      {/each}
    {/if}

  </div>

  {#if buttonSelected && textContinue}
    <div class="continue-btn-container">
      <button
        class="continue-btn"
        disabled={!isValidSelection}
        onclick={handleButtonSelected}
      >
        {textContinue}
      </button>
    </div>
  {/if}


</div>
<style>
.container {
  height: 100vh;
  height: 100dvh;
  max-height: 100vh;
  max-height: 100dvh;
  background: linear-gradient(135deg, #742bb0 0%, #4b6cb7 100%);
  color: white;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
.header {
  text-align: center;
  /* // margin-bottom: 2em; */
  padding: 1em;
  padding-top: 0;
  background: rgba(0, 0, 0, 0.8);
}
.logo {
  display: inline-block;
  width: min(10vmin, 1em);
  position: relative;
  top: 5px;
}
.title {
  font-size: min(8vmin, 2.5em);
  font-weight: bold;
  margin-bottom: 0.25em;
}
.subtitle {
  margin-top: 0.25em;
  font-size: min(4vmin, 1.25em);
  opacity: 0.8;
}
.search-container {
  max-width: 600px;
  margin: 0.5em auto;
  width: 100%;
  position: relative;
}

.button-container {
  margin: 0 auto 2em auto;
  width: 100%;
  position: relative;
}
.button-container.back {
  display: block;
  width: 100vw;
  text-align: left;
  margin: 0;
  background: rgba(0, 0, 0, 0.8);
}
.button, button {
  width: auto;
  text-align: left;
  padding: 1em 1.5em 1em 1.5em;
  border-radius: 50px;
  border: none;
  background: transparent;
  color: white;
  font-size: 1.1em;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}
.button.back {
  font-size: 1em;
  padding: 0.5em;
  min-width: auto;
  opacity: 0.7;
}
.button-container.major {
    text-align: center;
    margin: auto;
    background: rgba(0, 0, 0, 0.8);
    padding-bottom: 0.75em;
    display: block;
    text-align: center;
}
.button-container.major button {
    background: linear-gradient(135deg, #742bb0 0%, #4b6cb7 100%);
    display: inline-block;
}

.search-input {
  display: block;
  margin: auto;
  width: 95%;
  padding: 1em 1.5em 1em 3.5em;
  border-radius: 50px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: 1.1em;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}
.search-icon {
  position: absolute;
  left: 2.4em;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.7;
  z-index: 1;
}
.search-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}
.search-input:focus {
  outline: none;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.paper-wrapper {
  flex: 1;
  overflow-y: auto;
  padding: min(2vw, 2em);
  padding-top: 0;
  background: rgba(0, 0, 0, 0.8);
}
.papers-grid {
  display: flex;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5em;
  padding: 1em;

  /* // max-height: calc(100vh - 300px); */
  flex-direction: column;
  max-width: 1200px;
  margin: 0 auto;
}
.paper-card {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  padding: 4vmin;
  font-size: min(3vmin, 1.25em);
  cursor: pointer;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 2px solid transparent;
}
.paper-card:hover {
  transform: translateX(10px);
  background: rgba(255, 255, 255, 0.15);
}
.paper-card.selected, .paper-card:active {
  border-color: #00ffff;
  background: rgba(76, 142, 175, 0.1);
}
.paper-title {
  font-size: 1.2em;
  font-weight: bold;
  margin-bottom: 0.5em;
}
.paper-author {
  font-size: 0.9em;
  opacity: 0.8;
}
.paper-description {
  margin-top: 0.8em;
  margin-bottom: 0;
  font-size: 0.9em;
  opacity: 0.8;
  display: inline-block;
  padding: 0.5em 1.2em;
  border-radius: 20px;
  color: #000;
  background: #ccc;
}
.continue-btn-container {
  text-align: center;
  padding: 1em;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.2);
}
.continue-btn, button {
  background: #fff;
  color: #4527a0;
  border: none;
  padding: 1em 2em;
  border-radius: 50px;
  font-size: 1.1em;
  cursor: pointer;
  transition: all 0.3s ease;
  display: block;
  min-width: 200px;
}
.continue-btn:disabled {
  background: #bdbdbd;
  color: #777;
  cursor: not-allowed;
}
.continue-btn:not(:disabled):hover, button:hover {
  /* // transform: scale(1.05); */
  /* // box-shadow: 0 0 20px rgba(76, 175, 80, 0.3); */
  transform: scale(1.05);
  box-shadow: 0 0 15px #2196f3;
}
.divider {
  margin-top: 0.6em;
  margin-bottom: 0.3em;
  text-transform: uppercase;
  opacity: 0.7;
}
</style>